import axios from 'axios'
import * as API from "@/configs"

axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = API.base;
axios.defaults.timeout = 120000;


// 登录
export const login = params => {
    return axios.post('/api/login', params)
}

// 扫码登录
export const dingLogin = params => {
    return axios.post('/api/dingScanLogin', params)
}

// 权限申请单
export const sendSystemApply = params => {
    return axios.post('/api/sendSystemApply', params, { loading: true })
}

// 修改密码
export const setPassword = params => {
    return axios.post('/api/setPassword', params)
}

// 获取登录用户的信息
export const getUserInfo = () => {
    return axios.post('/api/me')
}

//获取商户信息
export const getBusiness = (params) => {
    return axios.get('/api/getBusiness', { params })
}

//商户登录
export const businessLogin = (params) => {
    return axios.post('/api/businessLogin', params)
}

// 获取用户权限信息接口
export const getPermissions = () => {
    return axios.post('/api/getPermissions')
}

// 退出登录
export const logout = () => {
    return axios.post('/api/logout')
}


//主播上播大屏
export const broadCastAnchorSchedule = (params) => {
    return axios.get('/api/broadCastAnchorSchedule', { params })
}

//获取下载压缩包列表
export const getDownLoadList = (params) => {
    return axios.get('/api/common/getDownLoadList', { params })
}

//异步任务
export const asyncWorkList = (params) => {
    return axios.get('/api/asyncWork/list', { params, loading: true })
}

// 终止任务
export const stopWork = params => {
    return axios.post('/api/asyncWork/stopWork', params, { loading: true })
}

// 取消任务
export const cancelWork = params => {
    return axios.post('/api/asyncWork/cancelWork', params, { loading: true })
}

// 重新执行任务
export const restartWork = params => {
    return axios.post('/api/asyncWork/restartWork', params, { loading: true })
}


// 上传
export const uploadResources = params => {
    return axios.post('/api/common/uploadResources', params)
}
// 文件上传oss上传
export const uploadOssResources = params => {
    return axios.post('/api/common/uploadOssResources', params, { loading: true, onUploadProgress: (e) => {
        let loadingText = document.querySelector('.api-loading .el-loading-text')
        if(loadingText){
            loadingText.innerHTML = parseInt(e.loaded / e.total * 100) + '%'
        }else{
            loadingText = document.createElement('p')
            loadingText.className = 'el-loading-text'
            loadingText.innerHTML = parseInt(e.loaded / e.total * 100) + '%'
            let loadingSpinner = document.querySelector('.api-loading .el-loading-spinner')
            if(loadingSpinner){
                loadingSpinner.appendChild(loadingText)
            }
        }
    } })
}
// 检测主播某个时间段与休假冲突
export const checkAnchorsVacation = params => {
    return axios.post('/api/schedule/checkAnchorsVacation', params, { loading: true })
}
// 店铺列表【批量调整打卡】
export const adjustAnchorLiveTime = params => {
    return axios.post('/api/schedule/adjustAnchorLiveTime', params)
}
// 上传主播上播语音接口
export const anchorVoice = params => {
    return axios.post('/api/anchor/anchorVoice', params)
}

// 根据文件名称下载文件
export const downloadFileByPath = params => {
    return axios.get('/api/common/downloadFileByPath', { params, responseType: 'blob' })
}

// 下载压缩包
export const downloadZipFileByPath = params => {
    return axios.get('/api/common/downloadZipFileByPath', { params, responseType: 'blob' })
}
// 删除单个/批量下载列表任务
export const cancelDownloadFile = params => {
    return axios.get('/api/common/cancelDownloadFile', { params })
}

// 选项值获取
export const getFieldOption = params => {
    return axios.get('/api/common/getFieldOption', { params })
}
// 历史导入查询列表
export const getImportLogsList = params => {
    return axios.get('/api/common/getImportLogsList', { params })
}

//首页接口-1
export const homeData = (params) => {
    return axios.get('/api/home/indexData', { params })
}
//首页接口-2
export const homeChartData = (params) => {
    return axios.get('/api/home/indexData', { params })
}


export const getCronHomepageData = (params) => {
    return axios.get('/api/home/getCronHomepageData', { params })
}


// 首页店铺列表
export const homeShopList = (params) => {
    return axios.get('/api/businessShop/homeShopList', { params })
}
// 导出店铺使用aop的情况
export const downloadAopUseCondition = params => {
    return axios.post('/api/businessShop/downloadAopUseCondition', params)
}
// 店铺列表
export const shopList = (params) => {
    return axios.get('/api/businessShop/shopList', { params })
}

// 首页主播列表
export const homeAnchorList = (params) => {
    return axios.get('/api/anchor/homeAnchorList', { params })
}

// 主播列表
export const anchorList = (params) => {
    return axios.get('/api/anchor/anchorList', { params })
}

// 主播列表
export const anchorPreview = (params) => {
    return axios.get('/api/anchor/anchorPreview', { params, loading: true })
}


// 获取管理员店铺列表
export const getHomeShopList = params => {
    return axios.post('/api/admin/getHomeShopList', params)
}

// 获取管理员店铺列表
export const getShopList = params => {
    return axios.post('/api/admin/getShopList', params)
}

// 获取月度每日业绩
export const getDailySales = params => {
    return axios.post('/api/admin/getDailySales', params)
}

//获取主播月度业绩
export const getAnchorSales = params => {
    return axios.post('/api/admin/getAnchorSales', params)
}

//获取店铺详细信息
export const getShopInfo = params => {
    return axios.get('/api/businessShop/shopInfo', { params })
}

//获取店铺排班
export const getShopSchedule = params => {
    return axios.get('/api/businessShop/getShopHomeSchedule', { params })
}

// 兼职主播上播
export const liveUp = params => {
    return axios.get('/api/admin/liveUp', { params })
}
export const sbtLiveUp = params => {
    return axios.post('/api/admin/liveUp', params)
}

// 兼职主播下播
export const liveDown = params => {
    return axios.get('/api/admin/liveDown', { params })
}
export const sbtLiveDown = params => {
    return axios.post('/api/admin/liveDown', params)
}


//获取店铺当前直播场次信息
export const getLiveInfo = params => {
    return axios.post('/api/admin/getLiveInfo', params)
}



//店铺绑定主播
export const getShopBindAnchor = params => {
    return axios.get('/api/admin/shopBindAnchor', { params })
}
export const sbtShopBindAnchor = params => {
    return axios.post('/api/admin/shopBindAnchor', params)
}

// 获取所有主播列表
export const getAnchorList = params => {
    return axios.post('/api/admin/getAnchorList', params)
}

// 新增店铺排班
export const scheduleAdd = params => {
    return axios.get('/api/admin/scheduleAdd', { params })
}
export const sbtScheduleAdd = params => {
    return axios.post('/api/admin/scheduleAdd', params)
}

//修改店铺排班
export const scheduleEdit = params => {
    return axios.get('/api/anchor/getAnchorSchedule', { params })
}
export const sbtScheduleEdit = params => {
    return axios.post('/api/admin/scheduleEdit', params)
}

//排班列表_排班信息
export const shopScheduleDetail = params => {
    return axios.get('/api/schedule/shopScheduleDetail', { params })
}

//店铺列表【导出排班】
export const downloadScheduleData = params => {
    return axios.post('/api/schedule/downloadScheduleData', params, { loading: true })
}

//删除店铺排班
export const scheduleDel = params => {
    return axios.post('/api/admin/scheduleDel', params)
}

//获取店铺直播列表
export const getShopLiveList = params => {
    return axios.get('/api/schedule/getShopLiveList', { params })
}

//直播异常处理GET
export const liveUnusualDeal = params => {
    return axios.get('/api/businessShop/liveUnusualDeal', { params })
}

//直播异常处理POST
export const sbtLiveUnusualDeal = params => {
    return axios.post('/api/businessShop/liveUnusualDeal', params)
}

//获取店铺直播数据
export const getScheduleRoomData = params => {
    return axios.get('/api/schedule/getScheduleRoomData', { params })
}

//月度销售
export const getMonthSaleList = params => {
    return axios.get('/api/businessShop/monthSale', { params })
}

//月度销售_销售明细_订单数明细
export const getOrderNumDetail = params => {
    return axios.get('/api/businessShop/getOrderNumDetail', { params })
}

//获取直播订单列表
export const getLiveOrderList = params => {
    return axios.post('/api/admin/getLiveOrderList', params)
}

//获取店铺月度销售汇总
export const getShopSalesTotal = params => {
    return axios.post('/api/dataSummary/getShopSalesTotal', params)
}

//主播数据汇总_列表
export const getAnchorSalesTotal = params => {
    return axios.post('/api/dataSummary/getAnchorSalesTotal', params)
}
// 主播数据汇总_导出业绩
export const downAnchorMonthSaleData = params => {
    return axios.get('/api/dataSummary/downAnchorMonthSaleData', { params, loading: true })
}
export const sbtDownAnchorMonthSaleData = params => {
    return axios.post('/api/dataSummary/downAnchorMonthSaleData', params)
}

// 考勤+保底数据
// 主播数据汇总_导出考勤+保底数据的模版
export const downloadMonthSummaryTemplate = params => {
    return axios.post('/api/dataSummary/downloadMonthSummaryTemplate', params)
}
// 主播数据汇总_导入考勤+保底数据
export const importMonthSummaryTemplate = params => {
    return axios.post('/api/dataSummary/importMonthSummaryTemplate', params)
}


//拉取订单
export const pullShopOrder = (params) => {
    return axios.get('/api/dataSummary/pullShopOrder', { params, loading: true })
}
// 拉取订单POST
export const sbtPullShopOrder = params => {
    return axios.post('/api/dataSummary/pullShopOrder', params, { loading: true })
}

// 业绩调整-列表
export const achieveList = params => {
    return axios.post('/api/achieve/index', params)
}
// 业绩调整-店铺下拉展示选项
export const getAnchorSearchShop = params => {
    return axios.post('/api/achieve/getAnchorSearchShop', params, { loading: true })
}
// 业绩调整-保存
export const achieveSave = params => {
    return axios.post('/api/achieve/save', params, { loading: true })
}

//获取店铺月度直播销售订单列表
export const getMonthLiveOrderList = params => {
    return axios.post('/api/admin/getMonthLiveOrderList', params)
}

//店铺月度销售明细主播排行
export const getAnchorMonthSaleRankingList = params => {
    return axios.post('/api/admin/getAnchorMonthSaleRankingList', params)
}

//上月结余退款-排班下的退款明细
export const getShopScheduleBalanceDetail = params => {
    return axios.get('/api/businessShop/getBalanceOrderNumDetail', { params })
}


// 合作主播_主播列表
export const businessAnchorList = params => {
    return axios.post('/api/business/businessAnchorList', params)
}
//合作主播_绑定店铺_店铺列表选项
export const getSelectShopList = params => {
    return axios.get('/api/business/getSelectShopList', { params })
}
// 合作主播_绑定店铺GET
export const bindShop = params => {
    return axios.get('/api/business/bindShop', { params })
}
export const sbtBindShop = params => {
    return axios.post('/api/business/bindShop', params)
}

// 合作主播_获取管理分类
export const getManageGoodsAtCategory = params => {
    return axios.get('/api/business/getManageGoodsAtCategory', { params })
}

// 删除擅长分类
export const delGoodsAtCategory = params => {
    return axios.post('/api/anchor/delGoodsAtCategory', params, { loading: true })
}

// 标签管理GET
export const shopLabelManage = params => {
    return axios.get('/api/businessShop/shopLabelManage', { params })
}

// 新增竞店标签
export const addRaceShopLabel = params => {
    return axios.post('/api/businessShop/addRaceShopLabel', params, { loading: true })
}

// 店铺选项
export const getLabelShopList = params => {
    return axios.get('/api/common/getShopList', { params })
}

// 竞店标签绑定店铺
export const setRaceShopLabelRelation = params => {
    return axios.post('/api/businessShop/setRaceShopLabelRelation', params, { loading: true })
}

// 竞店标签删除绑定店铺
export const delRaceShopLabelRelation = params => {
    return axios.post('/api/businessShop/delRaceShopLabelRelation', params, { loading: true })
}

// 删除竞店标签
export const delRaceShopLabel = params => {
    return axios.post('/api/businessShop/delRaceShopLabel', params, { loading: true })
}

// 店铺-管理竞店
export const mangeShopRaceShopRelation = params => {
    return axios.get('/api/businessShop/mangeShopRaceShopRelation', { params })
}

// 店铺-追加竞店标签GET
export const shopAddRaceShopLabel = params => {
    return axios.get('/api/businessShop/shopAddRaceShopLabel', { params })
}

// 店铺-追加竞店标签POST
export const sbtShopAddRaceShopLabel = params => {
    return axios.post('/api/businessShop/shopAddRaceShopLabel', params, { loading: true })
}

// 店铺-删除竞店标签
export const shopDelRaceShopLabel = params => {
    return axios.post('/api/businessShop/shopDelRaceShopLabel', params, { loading: true })
}

// 店铺-添加竞店GET
export const addShopRaceShopRelation = params => {
    return axios.get('/api/businessShop/addShopRaceShopRelation', { params })
}

// 店铺-添加竞店POST
export const sbtAddShopRaceShopRelation = params => {
    return axios.post('/api/businessShop/addShopRaceShopRelation', params, { loading: true })
}

// 店铺-删除/恢复竞店绑定状态
export const changeShopRaceShopRelation = params => {
    return axios.post('/api/businessShop/changeShopRaceShopRelation', params, { loading: true })
}

// 主播月度销售-导出-选项
export const getDownMonthSaleOption = params => {
    return axios.get('/api/anchor/getDownMonthSaleOption', { params })
}

// 合作主播_设置推荐主播
export const setRecommendAnchor = params => {
    return axios.post('/api/business/setRecommendAnchor', params)
}

// 合作主播_管理推荐主播GET
export const mangeRecommendAnchor = params => {
    return axios.get('/api/business/mangeRecommendAnchor', { params })
}
export const sbtMangeRecommendAnchor = params => {
    return axios.post('/api/business/mangeRecommendAnchor', params)
}

// 主播评定规则-列表
export const anchorRatingRulesList = params => {
    return axios.get('/api/anchorRatingRules/anchorRatingRulesList', { params })
}

// 主播评定规则-获取标签管理数据
export const getLabelList = params => {
    return axios.get('/api/anchorRatingRules/getLabelList', { params })
}

// 主播评定规则-编辑GET
export const anchorRatingRulesEdit = params => {
    return axios.get('/api/anchorRatingRules/anchorRatingRulesEdit', { params })
}
//主播评定规则-编辑POST
export const sbtAnchorRatingRulesEdit = params => {
    return axios.post('/api/anchorRatingRules/anchorRatingRulesEdit', params)
}

// 主播评定规则-停用启用POST
export const anchorRatingRulesUse = params => {
    return axios.post('/api/anchorRatingRules/anchorRatingRulesUse', params)
}

//主播直播主页
export const getAnchorInfo = params => {
    return axios.get('/api/anchor/anchorHomeInfo', { params })
}

//绑定店铺_get
export const anchorBindShop = params => {
    return axios.get('/api/anchor/anchorBindShop', { params })
}

//绑定店铺_post
export const sbtAnchorBindShop = params => {
    return axios.post('/api/anchor/anchorBindShop', params)
}

//获取主播排班
export const getAnchorSchedule = params => {
    return axios.get('/api/anchor/getAnchorHomeSchedule', { params })
}

//获取主播直播列表
export const getAnchorLiveList = params => {
    return axios.post('/api/anchor/getAnchorScheduleList', params)
}

//获取主播直播销售订单列表
export const getAnchorLiveOrderList = params => {
    return axios.post('/api/admin/getAnchorLiveOrderList', params)
}

//获取主播月度销售汇总
export const getAnchorMonthSalesTotal = params => {
    return axios.post('/api/anchor/monthSale', params)
}

//获取主播月度直播销售订单列表
export const getAnchorMonthLiveOrderList = params => {
    return axios.post('/api/admin/getAnchorMonthLiveOrderList', params)
}

// 管理员数据月度销售明细
export const getShopMonthSaleLiveList = params => {
    return axios.get('/api/businessShop/monthSaleDetail', { params })
}

// 上月结余退款
export const getLastMonthRefundTotal = params => {
    return axios.get('/api/businessShop/getBalanceList', { params })
}

// 上月结余退款-排班下的退款明细
export const getAnchorScheduleBalanceDetail = params => {
    return axios.post('/api/admin/getAnchorScheduleBalanceDetail', params)
}

export const getAnchorLastMonthRefundOrderList = params => {
    return axios.post('/api/admin/getAnchorLastMonthRefundOrderList', params)
}

// 店铺排班模板
export const shopScheduleTemplate = params => {
    return axios.get('/api/admin/ShopScheduleTemplate', { params, responseType: 'blob' })
}
export const sbtShopScheduleTemplate = params => {
    return axios.post('/api/admin/ShopScheduleTemplate', params)
}
// 下载错误的店铺排班数据
export const downloadShopScheduleData = params => {
    return axios.get('/api/admin/DownloadShopScheduleData', { params, responseType: 'blob' })
}
// 主播模卡压缩包下载
export const downloadModelImagesZip = params => {
    return axios.post('/api/download/downloadModelImagesZip', params, { responseType: 'blob' })
}

// 店铺、主播排班
export const scheduleShare = params => {
    return axios.post('/api/scheduleShare', params)
}

// 主播分享海报生成
export const setAnchorShare = params => {
    return axios.get('/api/anchor/anchorShare', { params })
}
export const sbtSetAnchorShare = params => {
    return axios.post('/api/anchor/anchorShare', params)
}

// 主播详情速览 _分享Get
export const singleAnchorShare = params => {
    return axios.get('/api/anchor/singleAnchorShare', { params })
}


// 获取分享主播数据
export const getAnchorShare = params => {
    return axios.get('/api/getAnchorShareCodeInfo', { params })
}


/*
    主播
*/
// 获取主播近7天排班
export const getScheduleByWeek = params => {
    return axios.post('/api/anchor/getScheduleByWeek', params)
}

// 获取主播绑定店铺
export const getBindShop = params => {
    return axios.post('/api/anchor/getBindShop', params)
}

// 获取解绑店铺数据
export const getUnbindShopLiveList = params => {
    return axios.post('/api/anchor/getUnbindShopLiveList', params)
}




// 获取主播店铺直播列表
export const getAnchorShopLiveList = params => {
    return axios.post('/api/anchor/getAnchorShopLiveList', params)
}

// 获取主播店铺月度销售
export const getAnchorShopSalesTotal = params => {
    return axios.post('/api/anchor/getAnchorShopSalesTotal', params)
}

// 全职主播上播
export const anchorLiveUp = params => {
    return axios.get('/api/anchor/liveUp', { params })
}
export const sbtAnchorLiveUp = params => {
    return axios.post('/api/anchor/liveUp', params)
}

// 全职主播下播
export const anchorLiveDown = params => {
    return axios.get('/api/anchor/liveDown', { params })
}
export const sbtAnchorLiveDown = params => {
    return axios.post('/api/anchor/liveDown', params)
}

// 获取店铺今日排班
export const getShopTodaySchedule = params => {
    return axios.post('/api/anchor/getShopTodaySchedule', params)
}

// 获取主播对应的店铺排班
export const getAnchorShopSchedule = params => {
    return axios.post('/api/anchor/getAnchorShopSchedule', params)
}

// 获取主播对应的店铺排班
export const getShopTodayLiveData = params => {
    return axios.post('/api/anchor/getShopTodayLiveData', params)
}

// 获取主播直播详细信息
export const getAnchorShopInfo = params => {
    return axios.post('/api/anchor/getAnchorInfo', params)
}

// 获取主播排班直播详情
export const getAnchorLiveDetail = params => {
    return axios.post('/api/anchor/getAnchorLiveDetail', params)
}

// 获取钉钉上播页面信息
export const getDingTalkNotifyInfo = params => {
    return axios.post('/api/getDingTalkNotifyInfo', params)
};

// 钉钉通知上播
export const dingTalkLiveUp = params => {
    return axios.post('/api/dingTalkLiveUp', params)
};

// 钉钉通知下播
export const dingTalkLiveDown = params => {
    return axios.post('/api/dingTalkLiveDown', params)
};



// 资料管理
export const getBusinessInfo = params => {
    return axios.get('/api/business/businessInfo', { params })
}
export const sbtGetBusinessInfo = params => {
    return axios.post('/api/business/businessInfo', params)
}
export const getManageShopList = params => {
    return axios.get('/api/business/getManageShopList', { params })
}
export const getAnchorMonthSaleShopSelect = params => {
    return axios.get('/api/anchor/getAnchorMonthSaleShopSelect', { params })
}

// 店铺管理
export const getBusinessShopList = params => {
    return axios.get('/api/business/shopList', { params })
}
export const sbtGetBusinessShopList = params => {
    return axios.post('/api/admin/getBusinessShopList', params)
}

// 开/关店
export const openBusinessShop = params => {
    return axios.post('/api/business/openBusinessShop', params)
}

// 记录日志
export const businessOperatorLog = params => {
    return axios.get('/api/business/businessOperatorLog', { params })
}

// 新增店铺
export const addBusinessShop = params => {
    return axios.get('/api/business/addBusinessShop', { params })
}
export const sbtAddBusinessShop = params => {
    return axios.post('/api/business/addBusinessShop', params)
}

// 编辑店铺
export const editBusinessShop = params => {
    return axios.get('/api/business/editBusinessShop', { params })
}
export const sbtEditBusinessShop = params => {
    return axios.post('/api/business/editBusinessShop', params)
}

// 获取商户所有主播列表
export const getBusinessAnchorList = params => {
    return axios.post('/api/admin/getCooperateAnchor', params)
}

// 编辑合作主播信息
export const editCooperateAnchor = params => {
    return axios.get('/api/admin/editBusinessAnchor', { params })
}
export const sbtEditCooperateAnchor = params => {
    return axios.post('/api/admin/editBusinessAnchor', params)
}

// 妆发师管理
// 妆发师列表
export const makeupArtistList = params => {
    return axios.get('/api/makeupArtist/makeupArtistList', { params })
}
// 新增妆发师
export const addMakeupArtist = params => {
    return axios.get('/api/makeupArtist/addMakeupArtist', { params })
}
export const sbtAddMakeupArtist = params => {
    return axios.post('/api/makeupArtist/addMakeupArtist', params)
}
// 编辑妆发师
export const editMakeupArtist = params => {
    return axios.get('/api/makeupArtist/editMakeupArtist', { params })
}
export const sbtEditMakeupArtist = params => {
    return axios.post('/api/makeupArtist/editMakeupArtist', params)
}



// 绑定主播列表
export const getBindPageAnchorList = params => {
    return axios.post('/api/admin/getBindPageAnchorList', params)
}


// 新增主播
export const addAnchor = params => {
    return axios.get('/api/anchor/anchorAdd', { params })
}
export const sbtAddAnchor = params => {
    return axios.post('/api/anchor/anchorAdd', params)
}

// 新增擅长分类
export const addGoodsAtCategory = params => {
    return axios.post('/api/anchor/addGoodsAtCategory', params, { loading: true })
}

// 管理员编辑主播信息
export const anchorEdit = params => {
    return axios.get('/api/anchor/anchorEdit', { params, loading: true })
}
export const sbtAnchorEdit = params => {
    return axios.post('/api/anchor/anchorEdit', params, { loading: true })
}

// 获取主播所有排班
export const getAnchorAllSchedule = params => {
    return axios.get('/api/admin/getAnchorAllSchedule', { params })
}

// 获取主播列表的信息（绑定主播）
export const getSelectAnchorList = params => {
    return axios.get('/api/admin/getSelectAnchorList', { params })
}

// 月度销售-导出数据GET
export const downShopMonthSale = params => {
    return axios.get('/api/businessShop/downShopMonthSaleData', { params })
}
export const sbtDownShopMonthSale = params => {
    return axios.post('/api/businessShop/downShopMonthSaleData', params, { responseType: 'blob' })
}

// 主播月度销售-导出GET
export const downAnchorMonthSale = params => {
    return axios.get('/api/anchor/downAnchorMonthSaleData', { params })
}
export const sbtDownAnchorMonthSale = params => {
    return axios.post('/api/anchor/downAnchorMonthSaleData', params, { responseType: 'blob' })
}

// 店铺月度销售-导出
export const checkDownMonthScheduleRoomData = params => {
    return axios.get('/api/admin/downMonthScheduleRoomData', { params })
}
export const downMonthScheduleRoomData = params => {
    return axios.post('/api/admin/downMonthScheduleRoomData', params, { responseType: 'blob' })
}
// 店铺月度销售-导出
export const downShopMonthSaleData = params => {
    return axios.get('/api/dataSummary/downShopMonthSaleData', { params })
}
export const sbtDownShopMonthSaleData = params => {
    return axios.post('/api/dataSummary/downShopMonthSaleData', params)
}

// 查看直播间数据
export const getAnchorScheduleRoomData = params => {
    return axios.get('/api/admin/getAnchorScheduleRoomData', { params })
}

// 店铺月度排班时长列表
export const shopMonthScheduleTimeList = params => {
    return axios.post('/api/schedule/shopMonthScheduleTimeList', params)
}
// 店铺列表【单日排班信息】
export const shopDayScheduleInfo = params => {
    return axios.post('/api/schedule/shopDayScheduleInfo', params)
}
// 主播列表【日历列表】
export const anchorMonthScheduleTimeList = params => {
    return axios.post('/api/schedule/AnchorMonthScheduleTimeList', params)
}
// 主播排班【点击日历色块_获取排班信息】
export const anchorDateScheduleTimeList = params => {
    return axios.get('/api/schedule/AnchorDateScheduleTimeList', { params })
}

// 解密bq加密的手机号
export const bqDecryptPhone = params => {
    return axios.post('/api/common/bqDecryptPhone', params)
}

// 店铺排班,获取选中月排班信息
export const getShopMonthScheduleInfo = params => {
    return axios.post('/api/schedule/shopMonthScheduleInfo', params, { loading: true })
}

// 一键停播
export const batchStopMonthSchedule = params => {
    return axios.get('/api/schedule/batchStopMonthSchedule', { params, loading: true })
}
export const sbtBatchStopMonthSchedule = params => {
    return axios.post('/api/schedule/batchStopMonthSchedule', params, { loading: true })
}

// 一键排班数据
export const shopDirectSetSchedule = params => {
    return axios.get('/api/schedule/shopDirectSetSchedule', { params, loading: true })
}

// 一键排班保存
export const shopDirectSetScheduleSave = params => {
    return axios.post('/api/schedule/shopDirectSetSchedule', params, { loading: true })
}

// 非定向主播排班_POST
export const shopNoAnchorSetSchedule = params => {
    return axios.post('/api/schedule/shopNoAnchorSetSchedule', params, { loading: true })
}

// 下载处理结果明细
export const downloadShopDirectResult = params => {
    return axios.post('/api/schedule/downloadShopDirectResult', params, { loading: true })
}

// 店铺排班【定向时段管理_添加主播】
export const shopAddDirectAnchorList = params => {
    return axios.get('/api/schedule/shopAddDirectAnchorList', { params })
}
// 店铺排班【定向时段管理_获取】
export const getShopDirectTimeSetting = params => {
    return axios.get('/api/schedule/shopDirectTimeSetting', { params, loading: true })
}

// 店铺排班【定向时段管理_保存】
export const shopDirectTimeSetting = params => {
    return axios.post('/api/schedule/shopDirectTimeSetting', params)
}
// 店铺排班【定向时段管理_删除】
export const shopDeleteDirectTimeSetting = params => {
    return axios.post('/api/schedule/shopDeleteDirectTimeSetting', params)
}

// 店铺排班【绑定主播_获取】
export const shopBindAnchor = params => {
    return axios.get('/api/schedule/shopBindAnchor', { params, loading: true })
}

// 店铺主页_解绑主播状态校验
export const getDelBindStatus = params => {
    return axios.get('/api/businessShop/getDelBindStatus', { params })
}

// 店铺排班【绑定主播_添加】
export const shopAddBindAnchorList = params => {
    return axios.get('/api/schedule/shopAddBindAnchorList', { params })
}

// 店铺排班【绑定主播_添加】
export const saveShopBindAnchor = params => {
    return axios.post('/api/schedule/shopBindAnchor', params, { loading: true })
}

// 店铺排班【排班下的可选主播列表】
export const shopSetScheduleAnchorList = params => {
    return axios.get('/api/schedule/shopSetScheduleAnchorList', { params, loading: true })
}

// 店铺排班【编辑排班_新增（包括停播）】
export const shopSetNewSchedule = params => {
    return axios.post('/api/schedule/shopSetNewSchedule', params, { loading: true })
}

// 店铺排班【点击排班日历展示的排班信息】
export const shopScheduleDetailList = params => {
    return axios.get('/api/schedule/shopScheduleDetailList', { params, loading: true })
}

// 店铺排班【编辑排班_保存（包括停播）】
export const shopSetSchedule = params => {
    return axios.post('/api/schedule/shopSetSchedule', params, { loading: true })
}

// 店铺排班【编辑排班_保存（包括停播）】
export const getShopSetSchedule = params => {
    return axios.get('/api/schedule/shopSetSchedule', { params, loading: true })
}

// 店铺排班【停播设置】
export const stopShopTimeLive = params => {
    return axios.post('/api/schedule/stopShopTimeLive', params)
}

// 主播排班
export const AnchorMonthScheduleInfo = params => {
    return axios.get('/api/schedule/AnchorMonthScheduleInfo', { params, loading: true })
}

// 主播排班【绑定店铺_获取】
export const AnchorBindShopInfo = params => {
    return axios.get('/api/schedule/AnchorBindShopInfo', { params, loading: true })
}
// 店铺排班【停播设置】
export const AnchorColorBlockSchedule = params => {
    return axios.post('/api/schedule/AnchorColorBlockSchedule', params, { loading: true })
}
// 店铺排班【停播设置】
export const shopDelSchedule = params => {
    return axios.post('/api/schedule/shopDelSchedule', params)
}
//
export const AnchorAddSchedule = params => {
    return axios.get('/api/schedule/AnchorAddSchedule', { params, loading: true })
}
//主播排班【新增排班_保存】
export const saveAnchorAddSchedule = params => {
    return axios.post('/api/schedule/AnchorAddSchedule', params, { loading: true })
}
// 主播排班【编辑排班_获取】
export const AnchorEditSchedule = params => {
    return axios.get('/api/schedule/AnchorEditSchedule', { params, loading: true })
}
//主播排班【编辑排班_保存】
export const saveAnchorEditSchedule = params => {
    return axios.post('/api/schedule/AnchorEditSchedule', params, { loading: true })
}
// 主播排班【绑定店铺_保存】
export const saveAnchorBindShopInfo = params => {
    return axios.post('/api/schedule/AnchorBindShopInfo', params)
}

// 主播排班【绑定店铺_保存】
export const shopDownloadFile = params => {
    return axios.get('/api/schedule/shopDownloadFile', { params, responseType: 'blob' })
}
export const AnchorDelSchedule = params => {
    return axios.post('/api/schedule/AnchorDelSchedule', params)
}

// 主播排班【新增/编辑排班 信息校验】
export const AnchorScheduleCheck = params => {
    return axios.post('/api/schedule/AnchorScheduleCheck', params, { loading: true })
}

// 同步考勤班次
export const syncAnchorWorkShift = params => {
    return axios.post('/api/schedule/syncAnchorWorkShift', params)
}

// 检测主播信息
export const getAnchorCompanyEmail = params => {
    return axios.post('/api/anchor/getAnchorCompanyEmail', params, { loading: true })
}

// 下载主播早中晚班(GET)
export const downloadDivideSchedulePart = params => {
    return axios.get('/api/schedule/downloadDivideSchedulePart', { params, loading: true })
}

// 下载主播早中晚班(POST)
export const sbtDownloadDivideSchedulePart = params => {
    return axios.post('/api/schedule/downloadDivideSchedulePart', params)
}

// 妆发师排班
// 妆发师排班列表
export const makeUpScheduleList = params => {
    return axios.get('/api/schedule/makeUpScheduleList', { params })
}
// 调整考勤班次导出
export const importMakeupAttend = params => {
    return axios.get('/api/schedule/importMakeupAttend', { params })
}
// 调整考勤班次导入
export const sbtImportMakeupAttend = params => {
    return axios.post('/api/schedule/importMakeupAttend', params)
}
// 月度排班汇总GET
export const exportMakeUpSchedule = params => {
    return axios.get('/api/schedule/exportMakeUpSchedule', { params })
}
// 月度排班汇总POST
export const sbtExportMakeUpSchedule = params => {
    return axios.post('/api/schedule/exportMakeUpSchedule', params)
}
// 新增排班GET
export const addMakeupSchedule = params => {
    return axios.get('/api/schedule/addMakeupSchedule', { params })
}
// 新增排班POST
export const sbtAddMakeupSchedule = params => {
    return axios.post('/api/schedule/addMakeupSchedule', params)
}
// 获取主播
export const getAppointSelectMakeupList = params => {
    return axios.get('/api/schedule/getAppointSelectMakeupList', { params })
}
// 新增排班POST
export const delMakeupAppointRecord = params => {
    return axios.post('/api/schedule/delMakeupAppointRecord', params)
}
// 排班记录列表
export const makeupAppointRecordList = params => {
    return axios.get('/api/schedule/makeupAppointRecordList', { params })
}
// 编辑出勤班次
export const editMakeupAttend = params => {
    return axios.get('/api/schedule/editMakeupAttend', { params })
}
// 编辑出勤班次
export const sbtEditMakeupAttend = params => {
    return axios.post('/api/schedule/editMakeupAttend', params)
}
// 妆发师日历排班明细
export const makeupMonthScheduleInfo = params => {
    return axios.get('/api/schedule/makeupMonthScheduleInfo', { params })
}
// 新增排班GET
export const addMakeupSingleSchedule = params => {
    return axios.get('/api/schedule/addMakeupSingleSchedule', { params })
}
// 新增排班GET
export const sbtAddMakeupSingleSchedule = params => {
    return axios.post('/api/schedule/addMakeupSingleSchedule', params)
}
// 获取预约排班明细
export const getMakeupBlockAppoint = params => {
    return axios.get('/api/schedule/getMakeupBlockAppoint', { params })
}
// 编辑排班
export const editMakeupAppointDetail = params => {
    return axios.get('/api/schedule/editMakeupAppointDetail', { params })
}
// 编辑排班
export const sbtEditMakeupAppointDetail = params => {
    return axios.post('/api/schedule/editMakeupAppointDetail', params)
}

// 人脸识别
// 人脸识别结果列表【列表页】
export const getStatisticsList = params => {
    return axios.get('/api/faceBodySearch/getStatisticsList', { params })
}
// 人脸识别结果列表【查看图集】
export const showFaceById = params => {
    return axios.get('/api/faceBodySearch/showFaceById', { params, loading: true })
}
// 人脸识别结果列表【标记为背景人脸】
export const signToBg = params => {
    return axios.get('/api/faceBodySearch/signToBg', { params })
}
// 人脸识别结果列表【关联主播get】
export const relateAnchorGet = params => {
    return axios.get('/api/faceBodySearch/relateAnchorGet', { params })
}
// 人脸识别结果列表【关联主播post】
export const relateAnchorPost = params => {
    return axios.post('/api/faceBodySearch/relateAnchorPost', params)
}
// 人脸样本列表【列表页】
export const getFaceEntitiesList = params => {
    return axios.get('/api/faceBodySearch/getFaceEntitiesList', { params, loading: true })
}
// 人脸样本列表【上传人脸】
export const addFaceByImg = params => {
    return axios.post('/api/faceBodySearch/addFaceByImg', params)
}
// 人脸样本列表【压缩包上传】
export const addFaceByZip = params => {
    return axios.post('/api/faceBodySearch/addFaceByZip', params)
}
// 人脸样本列表【删除人脸】
export const delFace = params => {
    return axios.get('/api/faceBodySearch/delFace', { params })
}
// 人脸样本列表【根据用户ID获取人脸图片】
export const getFaceByUser = params => {
    return axios.get('/api/faceBodySearch/getFaceByUser', { params })
}
// 人脸识别结果列表【批量应用识别结果】
export const batchApply = params => {
    return axios.post('/api/faceBodySearch/batchApply', params)
}

// 前端权限
export const getWebPermissions = params => {
    return axios.post('/api/getWebPermissions', params)
}
// 预警设置页
export const getWarningIndex = params => {
    return axios.get('/api/warning/index', { params })
}
// 导出模板/api/warning/exportTemplate
export const exportTemplate = params => {
    return axios.get('/api/warning/exportTemplate', { params, responseType: 'blob' })
}
// 导出预警用语
export const exportWarningWord = params => {
    return axios.get('/api/warning/exportWarningWord', { params, responseType: 'blob' })
}
// 导入预警用语
export const importWarningWord = params => {
    return axios.post('/api/warning/importWarningWord', params)
}

// 新增预警用语
export const addWord = params => {
    return axios.get('/api/warning/addWord', { params })
}
// 保存预警用语
export const saveRules = params => {
    return axios.post('/api/warning/saveRules', params, { loading: true })
}
// 获取预警列表/api/warning/getWarningList
export const getWarningList = params => {
    return axios.get('/api/warning/getWarningList', { params })
}


// 审核
// 妆发审核
// 爽约主播列表
export const breakAnchorList = params => {
    return axios.post('/api/service/audit/breakAnchorList', params, {
        headers: {
            accept: 'application/x..v3+json'
        }
    })
}
// 获取主播爽约列表--待审核预约列表(周期内)
export const anchorBreakAppointmentList = params => {
    return axios.post('/api/service/audit/anchorBreakAppointmentList', params, {
        headers: {
            accept: 'application/x..v3+json'
        }
    })
}
// 获取主播爽约列表--已审核预约列表
export const anchorAuditAppointmentList = params => {
    return axios.post('/api/service/audit/anchorAuditAppointmentList', params, {
        headers: {
            accept: 'application/x..v3+json'
        }
    })
}
// 审核爽约--核销
export const auditCompleteBreakAppointment = params => {
    return axios.post('/api/service/audit/auditCompleteBreakAppointment', params, {
        loading: true,
        headers: {
            accept: 'application/x..v3+json'
        }
    })
}
// 审核爽约--删除
export const auditDeleteBreakAppointment = params => {
    return axios.post('/api/service/audit/auditDeleteBreakAppointment', params, {
        loading: true,
        headers: {
            accept: 'application/x..v3+json'
        }
    })
}

// 排班审核
// 排班审核列表
export const getScheduleCheckList = params => {
    return axios.get('/api/check/getScheduleCheckList', { params })
}
// 同意排班/禁止排班
export const changeScheduleCheckStatus = params => {
    return axios.post('/api/check/changeScheduleCheckStatus', params, { loading: true })
}

// 补签审核-列表
export const operatorAppendCheckList = params => {
    return axios.post('/api/check/operatorAppendCheckList', params)
}
// 审核通过/不通过
export const setAppendTimeCheckResult = params => {
    return axios.post('/api/check/setAppendTimeCheckResult', params)
}

// 投放看板
// 实时监控
export const getMonitorList = params => {
    return axios.get('/api/launchBoard/getMonitorList', { params })
}
// 屏幕管理
export const screenShowSetting = params => {
    return axios.get('/api/launchBoard/screenShowSetting', { params })
}
// 屏幕管理 save
export const sbtScreenShowSetting = params => {
    return axios.post('/api/launchBoard/screenShowSetting', params, { loading: true })
}
// 指标配置
export const boardFieldSetting = params => {
    return axios.get('/api/launchBoard/boardFieldSetting', { params, loading: true })
}
// 屏幕管理 save
export const sbtBoardFieldSetting = params => {
    return axios.post('/api/launchBoard/boardFieldSetting', params, { loading: true })
}

// 全域推广
// 列表
export const getGlobalPromotion = params => {
    return axios.post('/api/launchBoard/getGlobalPromotion', params)
}
// 详情
export const getGlobalPromotionMoreTop = params => {
    return axios.post('/api/launchBoard/getGlobalPromotionMoreTop', params, { loading: true })
}
// 详情
export const getGlobalPromotionMoreContent = params => {
    return axios.post('/api/launchBoard/getGlobalPromotionMoreContent', params, { loading: true })
}
// 指标配置
export const promotionBoardFieldSetting = params => {
    return axios.get('/api/launchBoard/promotionBoardFieldSetting', { params, loading: true })
}
// 指标配置save
export const sbtPromotionBoardFieldSetting = params => {
    return axios.post('/api/launchBoard/promotionBoardFieldSetting', params, { loading: true })
}
// 指标信息下载
export const downloadPromotionBoardFieldValue = params => {
    return axios.post('/api/launchBoard/downloadPromotionBoardFieldValue', params)
}
// 预警设置
export const promotionWarningSettings = params => {
    return axios.get('/api/launchBoard/promotionWarningSettings', { params, loading: true })
}
// 预警设置save
export const sbtPromotionWarningSettings = params => {
    return axios.post('/api/launchBoard/promotionWarningSettings', params, { loading: true })
}



// WEBPACK FOOTER //
// ./src/api/index.js